
export default {
    name: 'share',
    data() {
        return {

        }
    },
    methods: {
        shareExternalLink(type) {
            //1是分享到Facebook 2是分享到twitter
            switch (type) {
                case 1:
                    window.open(`http://www.facebook.com/sharer.php?u=${window.location.href}`);
                    break
                case 2:
                    window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`);
                    break
            }

        }
    }


}
